import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "statistics-public__separator" }
const _hoisted_2 = { class: "row s-mb-lg" }
const _hoisted_3 = { class: "col-xs-12 statistics-public__number" }
const _hoisted_4 = { class: "row items-center justify-between" }
const _hoisted_5 = { class: "statistics-public__caption" }
const _hoisted_6 = { class: "statistics-public__number" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_digit_counter = _resolveComponent("digit-counter")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["statistics-public__title", { 'statistics-public__title--mobile': _ctx.isMobile }])
    }, _toDisplayString(_ctx.statisticTitle), 3),
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-xs-12 statistics-public__caption" }, "Всего предоставлено:", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_digit_counter, {
          count: _ctx.countIssues,
          "is-ssr": _ctx.isSsr
        }, null, 8, ["count", "is-ssr"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.issueDepList, (issue) => {
        return (_openBlock(), _createElementBlock("div", {
          key: issue.id,
          class: "col-xs-12 col-sm-6 col-md-4 s-mb-xl"
        }, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(issue.name), 1),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_digit_counter, {
              count: issue.count,
              "is-ssr": _ctx.isSsr
            }, null, 8, ["count", "is-ssr"])
          ])
        ]))
      }), 128))
    ])
  ], 512)), [
    [_vShow, _ctx.issueDepList.length !== 0]
  ])
}